export class InitAuthState {
  public static readonly type = '[Auth] Init Auth State';
  constructor() {}
}

export class LoginRequest {
  public static readonly type = '[Auth] Login Request';
  constructor(
    public username: string,
    public password: string,
    public returnUrl: string
  ) {}
}

export class LogoutRequest {
  public static readonly type = '[Auth] Logout Request';
  constructor(public returnUrl: string) {}
}
